import { ActivityLogEvent } from '@/constants/activityLogEvent';
import { Channel } from '@/pages/Timeline/components/MessageEvent/types';
import { ActivityLogAction } from '@/types/activityLog';

const messageEventTitle = (
  action: ActivityLogAction,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  activityLogData: Record<string, any> | null
) => {
  if (activityLogData?.message) {
    if ([Channel.SMS, Channel.EMAIL].includes(activityLogData.message?.channel)) {
      const sentViaIterable: boolean =
        activityLogData.message?.channel === Channel.SMS &&
        activityLogData.message?.app === 'iterable';

      return `${activityLogData.message.channel} ${
        action
          ? [
              ActivityLogEvent.INBOUND_MESSAGE_CREATED_EVENT.toString(),
              ActivityLogEvent.inbound_message_created.toString()
            ].includes(action)
            ? 'Received'
            : [
                  ActivityLogEvent.OUTBOUND_MESSAGE_CREATED_EVENT.toString(),
                  ActivityLogEvent.outbound_message_created.toString()
                ].includes(action)
              ? 'Sent'
              : ''
          : ''
      }${sentViaIterable ? ' via Iterable' : ''}`;
    }

    if (activityLogData.message?.channel === Channel.VOICE) {
      return `${
        action
          ? [
              ActivityLogEvent.INBOUND_MESSAGE_CREATED_EVENT.toString(),
              ActivityLogEvent.inbound_message_created.toString()
            ].includes(action)
            ? 'Inbound'
            : [
                  ActivityLogEvent.OUTBOUND_MESSAGE_CREATED_EVENT.toString(),
                  ActivityLogEvent.outbound_message_created.toString()
                ].includes(action)
              ? 'Outbound'
              : ''
          : ''
      } Call`;
    }

    if (activityLogData.message?.channel === Channel.PUSH) {
      return 'Push';
    }
  }

  return action ?? '';
};

export default messageEventTitle;
